/**
 * Builds the canonical url for the page being rendered, with query and hash dropped so that
 * tracking parameters do not split a page into several addresses.
 * @param asPath The router path of the current page
 * @param origin The origin to build against, defaults to the main frontend url
 * @returns The absolute url of the current page
 */
export function getSelfCanonicalUrl(asPath: string, origin?: string) {
    const path = (asPath || "/").split("?")[0].split("#")[0];

    return `${origin || process.env.NEXT_PUBLIC_FRONTEND_URL}${path}`;
}
